import React, { useMemo } from 'react';

import NoSSR from '../../components/NoSSR';
import { VerticalWidget } from '../../components/VerticalWidget';
import type { IVerticalListContext } from '../../contexts/VerticalListQueryContext';
import { VerticalListContext } from '../../contexts/VerticalListQueryContext';
import { convertVerticalListPageQuery } from '../../helpers/convertQuery';
import type { EnrichedOfferFromBff } from '../../interfaces/offers';
import type { TVerticalListPageQuery } from '../../types/query';

interface IProps {
  convertedQuery: Omit<IVerticalListContext, 'isMobile'>;
  offers: EnrichedOfferFromBff[];
}

const VerticalListPage = ({ convertedQuery, offers }: IProps) => {
  const providerValue = useMemo(() => ({ ...convertedQuery }), [convertedQuery]);

  return (
    <NoSSR>
      <VerticalListContext.Provider value={providerValue}>
        {offers && <VerticalWidget offers={offers} iframeId={convertedQuery.iframeId} />}
      </VerticalListContext.Provider>
    </NoSSR>
  );
};

VerticalListPage.getInitialProps = (ctx: App.ReduxNextPageContext<TVerticalListPageQuery>): IProps => {
  const { query, req } = ctx;

  const convertedQuery = convertVerticalListPageQuery(query);

  return {
    convertedQuery,
    offers: req.__OFFERS__,
  };
};

export default VerticalListPage;
